import React from 'react';
import PropTypes from 'prop-types';
import customPropTypes from 'apps/web_forms/utils/customPropTypes';
import BarcodeInput from './BarcodeInput';

const DriverLicenseInput = ({ element, formContext, onChangeValue }) => {
  return (
    <BarcodeInput
      element={element}
      onChangeValue={onChangeValue}
      formContext={formContext}
      isDriverLicense
    />
  );
};

DriverLicenseInput.propTypes = {
  element: PropTypes.shape({
    title: PropTypes.string,
    identifier: PropTypes.string,
    hint: PropTypes.string,
    validate_msg: PropTypes.string,
    barcode_type: PropTypes.string,
    allow_manual_override: PropTypes.bool,
  }).isRequired,
  formContext: customPropTypes.formContext.isRequired,
  onChangeValue: PropTypes.func.isRequired,
};

export default DriverLicenseInput;
